import React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { ItemGrid } from 'components';
import { withStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  root: {
    width: '100%',
  },
  appBar: {
    backgroundColor: '#EEEEEE',
    color: 'black',
    fontSize: '22px',
    fontWeight: 700,
  },
  menuBar: {
    display: 'flex',
    float: 'right',
  },
  iconButton: {
    margin: '0 10px',
  },
  title: {
    fontFamily: 'Raleway',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '20px',
    lineHeight: 'normal',
  },
});

class PrimaryAppBar extends React.Component {
  render() {
    const { classes, title, menuBar } = this.props;

    return (
      <div className={classes.root}>
        <AppBar className={classes.appBar} position='static'>
          <Toolbar>
            <ItemGrid xs={8} sm={8} md={8} noPadding>
              {title}
            </ItemGrid>
            <ItemGrid xs={4} sm={4} md={4}>
              <div className={classes.menuBar}>{menuBar}</div>
            </ItemGrid>
          </Toolbar>
        </AppBar>
      </div>
    );
  }
}

PrimaryAppBar.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PrimaryAppBar);
